import i18n from 'i18next';

//
// Constants need to be functions since initialisation of i18next is asynchronous.
//

// Password reset request strings

export const I18N_PASSWORD_RESET_TITLE = () =>
  i18n.t('resetPasswordPage.title');
export const I18N_PASSWORD_RESET_EMAIL_LABEL = () =>
  i18n.t('common.emailAddressLabel');
export const I18N_PASSWORD_RESET_SEND_LABEL = () =>
  i18n.t('resetPasswordPage.send');
export const I18N_PASSWORD_RESET_LOGIN_LABEL = () =>
  i18n.t('resetPasswordPage.logIn');

export const I18N_ENTER_EMAIL = () =>
  i18n.t('resetPasswordPage.validationErrors.enterEmail');
export const I18N_INVALID_EMAIL = () =>
  i18n.t('resetPasswordPage.validationErrors.invalidEmail');
export const I18N_UNKNOWN_EMAIL = () =>
  i18n.t('resetPasswordPage.validationErrors.unknownEmail');

export const I18N_RESET_REQUEST_SENT = () =>
  i18n.t('resetPasswordPage.passwordResetSent');

// Password reset confirmation strings

export const I18N_PASS_CONFIRM_TITLE = () =>
  i18n.t('resetPasswordPage.confirm.title');
export const I18N_PASS_CONFIRM_PASSWORD_LABEL = () =>
  i18n.t('resetPasswordPage.confirm.passwordLabel');
export const I18N_PASS_CONFIRM_REPEAT_PASSWORD_LABEL = () =>
  i18n.t('resetPasswordPage.confirm.repeatPassword');
export const I18N_TERMS_OF_USE_WARNING = () =>
  i18n.t('resetPasswordPage.confirm.termsOfUseWarning');
export const I18N_TERMS_OF_USE_LINK_LABEL = () =>
  i18n.t('resetPasswordPage.confirm.termsOfUseLinkLabel');
export const I18N_TERMS_NOT_AGREED = () =>
  i18n.t('resetPasswordPage.confirm.termsOfUseNotAgreed');
export const I18N_PASSWORD_CONFIRM = () =>
  i18n.t('resetPasswordPage.confirm.confirm');
export const I18N_CONTACT_FOOTER = (company: string) =>
  i18n.t('resetPasswordPage.confirm.contact', {company});

export const I18N_PASSWORD_REQUIRED = () =>
  i18n.t('resetPasswordPage.confirm.validationErrors.enterPassword');
export const I18N_PASSWORDS_DONT_MATCH = () =>
  i18n.t('resetPasswordPage.confirm.validationErrors.passwordsNotMatching');
export const I18N_INVALID_PASSWORD_RESET_LINK = () =>
  i18n.t('resetPasswordPage.confirm.validationErrors.invalidResetLink');
export const I18N_MINIMUM_PASSWORD_LENGTH = () =>
  i18n.t('resetPasswordPage.confirm.validationErrors.minimumPasswordLength');

export const I18N_PASSWORD_RESET_SUCCESSFUL = () =>
  i18n.t('resetPasswordPage.confirm.passwordResetSuccessful');
